import { TextProps } from '../../atoms/Text';
import { IconProps } from '../../atoms/Icon';
import { IconTooltipProps } from '../../atoms/IconTooltip';
import { UnderlineProps } from '../../atoms/Underline';

type ItemCardInternalProps = {
  labelText?: TextProps;
  underline?: UnderlineProps;
  icon?: IconProps;
  dateText?: TextProps;
  iconTooltip?: IconTooltipProps;
};

type ItemCardPropsValues = {
  'DefaultNone': ItemCardInternalProps;
  'IconError': ItemCardInternalProps;
  'IconNone': ItemCardInternalProps;
};

const propValues: ItemCardPropsValues = {
  'DefaultNone': {
    labelText: {
      align: 'Left',
      styleType: 'Medium',
      colour: 'Dark',
      type: 'Heading4',
    },
    underline: {
      styleType: 'Blue',
    },
    icon: {
      asset: 'Calendar',
      colour: 'IconSubdued',
    },
    dateText: {
      align: 'Left',
      styleType: 'Regular',
      colour: 'Subdued',
      type: 'Body3',
    },
  },
  'IconError': {
    labelText: {
      align: 'Left',
      styleType: 'Medium',
      colour: 'Dark',
      type: 'Heading4',
    },
    iconTooltip: {
    },
    underline: {
      styleType: 'Blue',
    },
    icon: {
      asset: 'Calendar',
      colour: 'IconSubdued',
    },
    dateText: {
      align: 'Left',
      styleType: 'Regular',
      colour: 'Subdued',
      type: 'Body3',
    },
  },
  'IconNone': {
    labelText: {
      align: 'Left',
      styleType: 'Medium',
      colour: 'Dark',
      type: 'Heading4',
    },
    iconTooltip: {
    },
    underline: {
      styleType: 'Blue',
    },
    icon: {
      asset: 'Calendar',
      colour: 'IconSubdued',
    },
    dateText: {
      align: 'Left',
      styleType: 'Regular',
      colour: 'Subdued',
      type: 'Body3',
    },
  },
};

const getProps = (type: string): ItemCardInternalProps => {
  const values: ItemCardInternalProps = propValues[type];
  if (!values) {
    console.error(`${type} props not found`);
    return {};
  }
  return values;
};

export default getProps;
